module.exports = __webpack_public_path__ + "img/case17-中储粮.b68f22db.png";